export default __webpack_public_path__ + "static/media/road-map-middle.5e53ce31.png";